"use client";

import { useState, useCallback } from "react";
import VirtuosoMainCard from "@/components/virtuosomaincard/VirtuosoMainCardTags";
import { GenreContentItem, GenreMeta } from "@/types/tag";
interface Props {
  title: string;
  movies: GenreContentItem[];
  meta?: GenreMeta;
  onLoadMore?: (page: number) => Promise<{
    items: GenreContentItem[];
    meta: GenreMeta;
  }>;
}
export default function TagsRelatedMovies({
  title,
  movies,
  meta,
  onLoadMore
}: Props) {
  const [items, setItems] = useState<GenreContentItem[]>(movies);
  const [currentMeta, setCurrentMeta] = useState<GenreMeta | undefined>(meta);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const hasMore = Boolean(currentMeta?.next_page);
  const handleLoadMore = useCallback(async () => {
    if (!hasMore || isLoadingMore || !onLoadMore || !currentMeta?.next_page) return;
    setIsLoadingMore(true);
    try {
      const result = await onLoadMore(currentMeta.next_page);
      setItems(prev => [...prev, ...result.items]);
      setCurrentMeta(result.meta);
    } finally {
      setIsLoadingMore(false);
    }
  }, [hasMore, isLoadingMore, onLoadMore, currentMeta?.next_page]);
  if (!items?.length) return null;
  return <section className="w-full flex flex-col">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-base md:text-lg font-bold text-foreground">{title}</h2>
      </div>
      <VirtuosoMainCard data={items} hasMore={hasMore} isLoadingMore={isLoadingMore} onLoadMore={handleLoadMore} />
    </section>;
}